export default __webpack_public_path__ + "static/img_product_olb-20bbc13fe40006eb9cf1ea6d70ace614.png";